import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { clientLandRoleEntity } from './land-role.models';
import { Action, createReducer, on } from '@ngrx/store';
import * as LandRoleActions from './land-role.actions';

export const LAND_ROLE_FEATURE_KEY = 'landRole';

export interface LandRoleState extends EntityState<clientLandRoleEntity> {
  landRole: clientLandRoleEntity | null;
  loaded: boolean;
  error?: string | null;
}

export const landRoleAdapter: EntityAdapter<clientLandRoleEntity> = createEntityAdapter<clientLandRoleEntity>();

export const initialLandRoleState: LandRoleState = landRoleAdapter.getInitialState({
  landRole: null,
  loaded: true,
  error: null,
});

const reducer = createReducer(
  initialLandRoleState,
  on(LandRoleActions.loadLandRole, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(LandRoleActions.loadLandRoleSuccess, (state, { landRole }) => ({
    ...state,
    landRole: landRole,
    loaded: true,
    error: null,
  })),
  on(LandRoleActions.loadLandRoleFailure, (state, { error }) => ({
    ...state,
    loaded: true,
    error: error,
  })),
  on(LandRoleActions.clearLandRole, (state) => {
    // LocalStorage löschen
    localStorage.removeItem('landRoleView');

    return {
      ...state,
      landRole: null,
      loaded: true,
      error: null,
    };
  })
);

export function landRoleReducer(state: LandRoleState | undefined, action: Action) {
  return reducer(state, action);
}
